<template>
  <div :id="mapId" class="MapBox"></div>
</template>

<script>
import { mapGetters } from "vuex";
import { MARKER_TYPES } from "@/utils/mapUtil/constants";
import {
  initMap,
  clearMarkers,
  fitView,
  loadMarkersBatch,
  findMarkerById,
  zoomPopupMarker,
  loadOrderPolygons,
  addPgAssetPolygons,
} from "@/utils/mapUtil/funcs.js";
import { layerServiceURL } from "@/utils/mapUtil/layerServiceURL";
import { handleZoomForBoundary } from "@/utils/mapUtil/leafletFun";
import OrderInfoWindow from "@/views/productionService/components/orderInfoWindow.vue";

export default {
  data() {
    return {
      mapId: "order-company-machinery-map",
      map: null,
      lon: window.global.view.center[0],
      lat: window.global.view.center[1],
      zoom: window.global.view.zoom,
    };
  },
  computed: {
    ...mapGetters(["topSelectAreacode", "topSelectAreaname"]),
  },
  //监听地区的变化设为中心点
  watch: {
    async topSelectAreaname() {
      await clearMarkers(this.map.tempLayer);
      await this.loadAllMarkers();
      await fitView(this.map);
    },
  },

  mounted() {
    this.init();
    // 监听地图缩放事件, 触发加载对应层级的行政区划边界
    this.map.on("zoomend", this.handleZoomEnd);
    this.$bus.$on("land-map-center-id-change", ({ type, id }) => {
      this.setCenterByMarkerId(type, id);
    });
  },

  beforeUnmount() {
    // 移除事件监听
    this.$bus.$off("land-map-center-id-change");
  },

  methods: {
    /**
     * 初始化
     */
    async init() {
      this.map = initMap(this.mapId, {
        center: [this.lat, this.lon],
        zoom: this.zoom,
      });
      await this.loadAllMarkers();
      await fitView(this.map);
    },

    /**
     * 添加所有markers
     */
    async loadAllMarkers() {
      for (const type of [
        MARKER_TYPES.order,
        MARKER_TYPES.machinery,
        MARKER_TYPES.company,
      ]) {
        try {
          await loadMarkersBatch(
            type,
            {
              areaCode: this.topSelectAreacode,
              serviceType: this.$route.query.code == "one" ? 1 : 2,
              orderType: this.$route.query.code == "one" ? 1 : 2,
            }, //不加current和size，默认1 和 500
            this.map
          );
        } catch (error) {
          console.error(`添加marker失败, ${type}:`, error);
        }
      }
      let dataList = this.map.tempLayer.getLayers().map((J) => J.properties);
      let arr = await loadOrderPolygons(dataList, this.map.tempLayer);
      addPgAssetPolygons(this.map.tempLayer, arr, OrderInfoWindow);
    },

    /**
     * 新增 托管地块和农事服务商 定位方法
     */
    setCenterByMarkerId(type, id) {
      let marker = findMarkerById(type, id, this.map.tempLayer);
      zoomPopupMarker(marker, this.map);
    },

    /**
     * 根据缩放层级加载对应的行政区划边界，并清除其他层级的边界
     */
    handleZoomEnd() {
      const zoomRanges = [
        {
          layerType: "service",
          range: [5, 7],
          ...layerServiceURL["china_province"],
        },
        {
          layerType: "service",
          range: [7, 9],
          ...layerServiceURL["china_city"],
        },
        {
          layerType: "service",
          range: [9, 12],
          ...layerServiceURL["china_county"],
        },
        {
          layerType: "service",
          range: [12, 20],
          ...layerServiceURL["china_township"],
        },
      ];
      handleZoomForBoundary(this.map, this, zoomRanges);
    },
  },
};
</script>

<style lang="less" scoped>
.MapBox {
  width: 100%;
  height: 100%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
</style>
